import PropTypes from 'prop-types';
import { richtextType } from './richtext';
import { linkType } from './link';
import { responsiveImageType } from './image';
import { responsiveVideoType } from './video';
import { typographyType } from './typography';

// eslint-disable-next-line import/prefer-default-export
export const itemType = PropTypes.shape({
  title: richtextType.isRequired,
  copy: richtextType,
  orientation: PropTypes.string.isRequired,
  hero_image: responsiveImageType,
  position: PropTypes.string.isRequired,
  nav_title: PropTypes.string,
  hero_video: responsiveVideoType,
  cta: linkType,
  title_typography: typographyType,
});
